import validators, {validatorTypes} from '@utils/validators';
import {
    CIDR_RANGES_MAX_LENGTH,
    INVALID_CIDR_FORMAT,
    splitCidrTokens,
} from '@modules/events/utils/eventContentWatermarkingCidrHelper';

const DESCRIPTION_MAX_LENGTH = 200;
export const WATERMARKING_CIDR_OR_CLIENT_REQUIRED = 'At least one of CIDR ranges or Clients must be filled.';

const hasValue = (value) => !validatorTypes.required.validate(value);

const validateCidrToken = (token) => {
    if (!validatorTypes.cidrIPv4.validate(token) || !validatorTypes.cidrIPv6.validate(token)) {
        return {};
    }

    return validators.cidrIPv4(token, 'cidrs', INVALID_CIDR_FORMAT);
};

const validate = (values) => {
    const errors = {};

    Object.assign(errors, validators.required(values.event_content, 'event_content'));

    if (!hasValue(values.cidrs) && !hasValue(values.clients)) {
        errors.cidrs = WATERMARKING_CIDR_OR_CLIENT_REQUIRED;
        errors.clients = WATERMARKING_CIDR_OR_CLIENT_REQUIRED;
    }

    Object.assign(errors, validators.maxLength({
        value: values.cidrs,
        maxLength: CIDR_RANGES_MAX_LENGTH,
    }, 'cidrs'));
    Object.assign(errors, validators.maxLength({
        value: values.description,
        maxLength: DESCRIPTION_MAX_LENGTH,
    }, 'description'));

    if (values.cidrs && String(values.cidrs).trim()) {
        for (const token of splitCidrTokens(values.cidrs)) {
            const tokenErrors = validateCidrToken(token);

            if (tokenErrors.cidrs) {
                errors.cidrs = tokenErrors.cidrs;
                break;
            }
        }
    }

    return errors;
};

export default validate;
